<!--选做题-->
<template>
	<div class="drop-position" ref="config" :style="concludeWH">
		<vue-drag-resize
			class="mark-out-position"
			v-for="(rectItem, rectIndex) in rectDetail"
			:key="rectIndex"
			:x="rectItem.areaMinX"
			:y="rectItem.areaMinY"
			:w="operateWidth(rectItem)"
			:h="operateHeight(rectItem)"
			:isActive="rectIndex === tempActiveArea"
			:isDraggable="rectIndex === tempActiveArea"
			:isResizable="rectIndex === tempActiveArea"
			@clicked="exitDrag"
			@resizestop="rectDragResize($event, rectIndex)"
			@dragstop="rectDragResize($event, rectIndex)"
			@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY)"
		>
			<template>
				<div
					v-if="JSON.parse(rectItem.remarks).type === 'likeObj'"
					class="rect-title-wrap"
					@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY)"
				>
					<vue-drag-resize
						class="mark-list"
						v-for="(item, index) in JSON.parse(rectItem.appendInfo).box"
						:key="`${rectIndex}-${index}-rect`"
						:x="item.x"
						:y="item.y"
						:w="item.w"
						:h="item.h"
						:n="item.n"
						:curIndex="`${rectIndex}-${index}`"
						:isActive="false"
						:isResizable="false"
						:isDraggable="true"
						@dragstop="selectDragStop($event, rectIndex, index)"
						@mousedown.native="fixRectList($event, rectItem, item, rectIndex, index)"
					>
						<span class="mark-val">{{ item.smallTopic }}</span>
					</vue-drag-resize>
				</div>
				<span class="big-num" v-if="JSON.parse(rectItem.remarks).type === 'likeSub'">选做题：{{ JSON.parse(rectItem.remarks).selectName || '' }}</span>
				<i v-show="JSON.parse(rectItem.remarks).version" class="iconfont iconlajitong1 del-icon" @click="dropArea({ val: rectItem, state: true })"></i>
				<div v-show="JSON.parse(rectItem.remarks).version" class="drop-menu">
					<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
						<i class="iconfont iconjiantou-down "></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
							<el-dropdown-item command="del">删除选区</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</template>
		</vue-drag-resize>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
export default {
	name: 'subject',
	mixins: [isDragResize, drawRect, fixWH, fixRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			//当前试卷
			currentImg: '',
			//所有框子
			rectDetail: [],
			query: this.$route.query,
			//类型
			emitType: 'tempChooseList',
			//no use
			selActiveIndex: -1
		}
	},
	watch: {
		tempCurrentImgIndex() {
			this.fixCurrentSel(this.tempChooseList)
		},
		tempEditImgInfo: {
			handler(val) {
				this.currentImg = val.list[this.tempCurrentImgIndex.curIndex]
			},
			immediate: true,
			deep: true
		},
		tempChooseList: {
			handler(val) {
				this.fixCurrentSel(val)
			},
			immediate: true,
			deep: true
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempChooseList']) },
	methods: {
		...mapActions('examination/databases', ['set', 'get']),
		fixCurrentSel(val) {
			this.rectDetail = []
			if (val.length === 0) return false
			val.map((res, index) => {
				if (res.remarks && this.tempCurrentImgIndex.curIndex + 1 === Number(JSON.parse(res.remarks).page)) {
					const remark = JSON.parse(res.remarks)
					remark.currentIndex = index
					res.remarks = JSON.stringify(remark)
					this.rectDetail.push(res)
				}
			})
			console.log(this.rectDetail)
		},
		// 拖拽，缩放
		rectDragResize(newRect, index) {
			this.rectDetail[index].areaMinX = newRect.left
			this.rectDetail[index].areaMinY = newRect.top
			this.rectDetail[index].areaMaxX = newRect.left + newRect.width
			this.rectDetail[index].areaMaxY = newRect.top + newRect.height
			this.refreshBox(index)
		},
		// 拖拽小框框
		selectDragStop(newRect, rectIndex, index) {
			let appendInfo = JSON.parse(this.rectDetail[rectIndex].appendInfo)
			let box = appendInfo.box
			box[index].x = newRect.left
			box[index].y = newRect.top
			appendInfo.box = box
			this.rectDetail[rectIndex].appendInfo = JSON.stringify(appendInfo)
			this.refreshBox(rectIndex)
		},
		refreshBox(index) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: this.rectDetail[index]['pkId'],
				ppiStr: JSON.stringify(this.rectDetail[index])
			}
			this.$post('Cv/refreshPpi', params).then(() => {
				this.$message.success('成功')
			})
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
.big-num {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 60px;
	color: red;
	font-weight: bolder;
}
.small-num {
	font-size: 16px;
	color: red;
	font-weight: bolder;
}
</style>
